window.PlummeI18n.register('no', {
  'investments.quickPurchaseTitle': 'Kontroller og godkjenn kjøpet',
  'investments.quickPurchaseIntro': 'Plumme har lest dokumentet og klargjort kjøpet. Kontroller beløpene og godkjenn.',
  'investments.quickExistingInstrument': 'Kjøpet registreres på eksisterende investering: {name}.',
  'investments.quickClassification': 'Regnskapskonto',
  'investments.quickCurrentAsset': '1810 · Markedsbasert omløpsmiddel',
  'investments.quickCurrentAssetName': 'Markedsbaserte aksjer og verdipapirfondsandeler',
  'investments.quickLongTerm': '1350 · Langsiktig investering',
  'investments.quickBankRequired': 'Foretaket må ha en aktiv NOK-bankkonto før kjøpet kan bokføres.',
  'investments.quickTaxLater': 'Avklares automatisk fra års- og skattedokumentasjonen',
  'investments.editCurrency': 'Endre valuta',
  'investments.editFact': 'Rediger {field}',
  'investments.quickActualNokAmount': 'Faktisk belastet i NOK',
  'investments.quickActualNokHelp': 'Skriv inn NOK-beløpet som faktisk ble belastet for kjøpet i {currency}.',
  'investments.quickResult': 'Når du godkjenner, oppretter Plumme investeringen, bokfører kjøpet og oppdaterer beholdningen. En entydig banktransaksjon kobles automatisk nå eller neste gang Investeringer åpnes.',
  'investments.quickApprove': 'Godkjenn, bokfør og oppdater beholdning',
  'investments.quickApproving': 'Bokfører kjøpet …',
  'investments.quickSaleTitle': 'Kontroller og godkjenn salget',
  'investments.quickSaleIntro': 'Plumme har lest salgsbilaget og beregnet regnskaps- og skatteeffekten fra registrert historikk.',
  'investments.saleCalculating': 'Beregner FIFU og kostprisgrunnlag …',
  'investments.saleCannotQuickApprove': 'Dette mangler før salget kan hurtiggodkjennes',
  'investments.saleInstrumentMissing': 'Investeringen finnes ikke i registeret. Registrer inngående beholdning eller tidligere kjøp først.',
  'investments.saleInstrumentAmbiguous': 'Flere investeringer matcher dokumentet. Velg riktig investering manuelt.',
  'investments.saleTaxTreatmentMissing': 'Skattebehandlingen er ikke avklart for investeringen.',
  'investments.instrumentTypeUnsupported': 'Instrumenttypen er gjenkjent, men bokføring for denne typen støttes ikke ennå.',
  'investments.netSettlement': 'Nettooppgjør',
  'investments.releasedBookCost': 'Frigitt regnskapsmessig kostpris',
  'investments.releasedBookValue': 'Frigitt bokført verdi',
  'investments.releasedTaxCost': 'Frigitt skattemessig kostpris',
  'investments.bookProfitLoss': 'Regnskapsmessig gevinst/tap',
  'investments.taxProfitLoss': 'Skattemessig gevinst/tap',
  'investments.fifoCalculation': 'Beregnet FIFU',
  'investments.quickSaleResult': 'Godkjenning bokfører salget, oppdaterer beholdningen og kobler et entydig bankoppgjør automatisk.',
  'investments.quickApproveSale': 'Godkjenn, bokfør og oppdater beholdning',
  'investments.completeSale': 'Fyll ut salget',
});
window.PlummeI18n.register('en', {
  'investments.quickPurchaseTitle': 'Review and approve purchase',
  'investments.quickPurchaseIntro': 'Plumme has read the document and prepared the purchase. Review the amounts and approve.',
  'investments.quickExistingInstrument': 'The purchase will be recorded against the existing investment: {name}.',
  'investments.quickClassification': 'Accounting account',
  'investments.quickCurrentAsset': '1810 · Marketable current asset',
  'investments.quickCurrentAssetName': 'Marketable shares and fund units',
  'investments.quickLongTerm': '1350 · Long-term investment',
  'investments.quickBankRequired': 'The business needs an active NOK bank account before the purchase can be posted.',
  'investments.quickTaxLater': 'Resolved automatically from annual and tax documentation',
  'investments.editCurrency': 'Edit currency',
  'investments.editFact': 'Edit {field}',
  'investments.quickActualNokAmount': 'Actual amount charged in NOK',
  'investments.quickActualNokHelp': 'Enter the NOK amount actually charged for the purchase in {currency}.',
  'investments.quickResult': 'Approval creates the investment, posts the purchase and updates the holding. A unique bank transaction is matched now or the next time Investments opens.',
  'investments.quickApprove': 'Approve, post and update holding',
  'investments.quickApproving': 'Posting purchase …',
  'investments.quickSaleTitle': 'Review and approve sale',
  'investments.quickSaleIntro': 'Plumme has read the sale document and calculated the accounting and tax effect from recorded history.',
  'investments.saleCalculating': 'Calculating FIFO and cost bases …',
  'investments.saleCannotQuickApprove': 'Required before this sale can be approved directly',
  'investments.saleInstrumentMissing': 'The investment is not in the register. Record opening holdings or earlier purchases first.',
  'investments.saleInstrumentAmbiguous': 'More than one investment matches the document. Select the correct investment manually.',
  'investments.saleTaxTreatmentMissing': 'The investment tax treatment has not been resolved.',
  'investments.instrumentTypeUnsupported': 'The instrument type was recognized, but posting for this type is not supported yet.',
  'investments.netSettlement': 'Net settlement',
  'investments.releasedBookCost': 'Released accounting cost',
  'investments.releasedBookValue': 'Released carrying amount',
  'investments.releasedTaxCost': 'Released tax cost',
  'investments.bookProfitLoss': 'Accounting gain/loss',
  'investments.taxProfitLoss': 'Tax gain/loss',
  'investments.fifoCalculation': 'Calculated FIFO',
  'investments.quickSaleResult': 'Approval posts the sale, updates the holding and automatically matches an unambiguous bank settlement.',
  'investments.quickApproveSale': 'Approve, post and update holding',
  'investments.completeSale': 'Complete sale',
});
